module.exports = __webpack_public_path__ + "img/kobzeva.e007182d.jpg";